module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "shell-wrap"
  }, [_c('p', {
    staticClass: "shell-top-bar"
  }, [_vm._v("Sistema de Acesso")]), _vm._v(" "), _c('ul', {
    staticClass: "shell-body",
    staticStyle: {
      "min-height": "200px",
      "max-height": "500px",
      "overflow": "auto"
    }
  }, [_c('li', {
    staticClass: "salert"
  }, [_vm._v("Iniciando transição para o controle do leilão local. Aguarde, pode demorar até 15 minutos...")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.shellResponse), function(shellOutput) {
    return _c('li', {
      staticClass: "salert"
    }, [_vm._v(_vm._s(shellOutput))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "salert"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85c2bca8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/ShellSync.vue
// module id = 1817
// module chunks = 17